
<template>
  <div class="font app-content isVisitor bg-white" >
    <b-container class='mt-4 px-0'>
      <b-row>
        <b-col cols='10' class='mx-auto'>
          <b-row>
            <b-col cols='7' class='mx-auto mt-4 ml-3 font-org-right-blue'>
              <h4><b-icon icon="files" class='mr-2'></b-icon>お気に入り一覧</h4>
            </b-col>
            <b-col cols='5' class='mx-auto mt-4 px-4 text-right'>
              <AgencyList v-if="isAgency" @update="onUpdateAll"></AgencyList>
            </b-col>
          </b-row>

          <b-row v-if="userList.length > 0" class='mt-5'>
            <b-col class='mx-2 col-30 my-2' v-for='userInfo in userList' :key='userInfo.id'>
              <b-row class="p-2 user-box">
                <b-col cols='12' class='p-0'>
                 <img class="user-img m-0" alt="" :src="userInfo.profile_image">
                </b-col>
                <b-col cols='12' class='pl-0'>
                  <router-link :to='"./jobSeeker/" + userInfo.id'>
                    <p class="mb-0 name mt-3">{{$t("message.name")}} / {{ getName(userInfo)}} </p>
                  </router-link>
                </b-col>
                <b-col cols='12' class='pl-0'>
                  <p class="mb-0 gender">{{$t("message.year_old")}} / {{ birth2age(userInfo.birthday)}}  {{$t("message.gender")}} / {{ getGender(userInfo.gender) }} {{$t("message.country_of_origin")}}/ {{ userInfo.nationality }}</p>
                </b-col>
                <b-col cols='12' class='pl-0'>
                    <p class="mb-0 origin">現住所 / {{ userInfo.live_area }} / 日本在歴 / {{ userInfo.experience_japan }}年</p>
                </b-col>
                <b-col cols='12' class='pl-0'>
                    <p class="mb-0 pr">PR / {{ userInfo.self_pr}}</p>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row v-else class='mt-5 text-center'>
            <p>お気に入りしているユーザーはいません</p>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
import AgencyList from "@/components/Agency/AgencyList"
export default {
  components: {AgencyList},
  data() {
    return{
      idToken: localStorage.idToken,
      userList: [],
      meta: {},
      searchOption: {
        keyword: null,
        country: [],
        minOld: null,
        maxOld: null,
        gender: null,
        japanese: null,
      },
      isAgency: false,
      countryList: [
        { value: 'ベトナム', text: this.$i18n.t('message.vietnum') },
        { value: 'ラオス', text: this.$i18n.t('message.laos') },
        { value: 'マレーシア', text: this.$i18n.t('message.malaysia') },
        { value: 'バングラデッシュ', text: this.$i18n.t('message.bangladesh') },
        { value: 'インド', text: this.$i18n.t('message.indo') },
        { value: 'モンゴル', text: this.$i18n.t('message.mongol') },
        { value: 'ネパール', text: this.$i18n.t('message.nepal') },
        { value: 'インドネシア', text: this.$i18n.t('message.indonesia') },
        { value: 'タイ', text: this.$i18n.t('message.th') },
        { value: 'フィリピン', text: this.$i18n.t('message.philipine') },
        { value: 'ミャンマー', text: this.$i18n.t('message.my') },
        { value: 'ウズベキスタン', text: this.$i18n.t('message.uzbekistan') },
        { value: 'パキスタン', text: this.$i18n.t('message.pakistan') },
        { value: '日本', text: this.$i18n.t('message.japan') },
      ],
      genderOptions: [
        { text: this.$i18n.t('message.man'), value: 'man' },
        { text: this.$i18n.t('message.woman'), value: 'female' }
      ]
    }
  },
  methods: {
    getName(user){
      var result =''
      if(user.first_name != null){
        result += user.first_name
      }
      if(user.sur_name != null){
        result += ' ' + user.sur_name
      }
      if(user.last_name != null){
        result += ' ' +user.last_name
      }
      return result
    },
    birth2age(day) {
      if( day != null){
        var birth = moment(day);
        return moment().diff(birth, 'years') + "歳";
      }
      return ''
    },
    getGender(gender){
      if(gender == "man"){
        return "男性"
      }else if(gender == "woman"){
        return "女性"
      }else{
        return "その他"
      }
    },
    onChangeSearch() {
      this.$store.commit('setLoading', true)
      this.fetchUsers(this.searchOption.keyword)
    },
    search(){
      var u = "?country=" + this.searchOption.country.join(',') + "&minOld" + this.searchOption.minOld + "&maxOld=" + this.searchOption.maxOld + "&gender" + this.searchOption.gender

      axios
        .get(process.env.VUE_APP_API + "/api/org/users" + u, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          this.meta = response.data.meta
          this.userList = response.data.users
        }).catch(error => {
          console.log('this is org error', error)
        })
    },
    fetchUsers(w="") {
      axios
        .get(process.env.VUE_APP_API + "/api/org/favorite_users?word=" + w, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          this.userList = response.data.users
          this.$store.commit('setLoading', false)
        }).catch(error => {
          console.log('this is org error', error)
        })
    },
    checkAgency() {
      var idToken = localStorage.idToken
      axios.get(process.env.VUE_APP_API + "/api/agcy/agency/1", {headers: {'Authorization': 'Bearer ' + idToken}})
        .then(() => { this.isAgency = true})
    },
    onUpdateAll() {
      this.$store.commit('setLoading', true)
      this.fetchUsers()
    }


  },
  mounted(){
    this.fetchUsers()
  }
}

</script>
<style scoped type="scss">
.box-border{
  border: 1px solid #000000;
}
.user-box{
  border: 1px solid #4298F7;
  padding: 14px;

}
p.name {
  font-size: 14px;
}
p.gender, p.origin, p.pr  {
  font-size: 14px;
}
.col-30{
  flex: 0 0 29%;
  max-width: 29%;
}
.range-number{
  width: 5rem; display: inline
}
.user-img {
  width: 100%;
  height: 210px;
  object-fit: cover;
  background-color: #777;
}
</style>
